import axios from "axios";
import API_V2_URL from "@/constants/API_V2_URL";
import headers from "../constants/headers";

axios.defaults.headers.common.Authorization = `Bearer ${headers.access_token}`;

const customFolderService = {
  getAllCustomFolders() {
    return axios.get(`${API_V2_URL()}/folders/folder_customs`);
  },
  getCustomFolder(id) {
    return axios.get(`${API_V2_URL()}/folders/folder_customs/${id}`);
  },
  createCustomFolder(body) {
    return axios.post(`${API_V2_URL()}/folders/folder_customs`, body);
  },
  deleteCustomFolder(customFolderId) {
    return axios.delete(
      `${API_V2_URL()}/folders/folder_customs/${customFolderId}`
    );
  },
  deleteFolderFromCustomFolder(customFolderId, folderId) {
    return axios.delete(
      `${API_V2_URL()}/folders/folder_customs/${customFolderId}/${folderId}`
    );
  },
  addFolderToCustomFolder(customFolderId, folderId) {
    return axios.put(
      `${API_V2_URL()}/folders/folder_customs/${customFolderId}/${folderId}`
    );
  }
};

export default customFolderService;



// WEBPACK FOOTER //
// ./src/services/CustomFolderService.js